// extracted by mini-css-extract-plugin
module.exports = {"menuClassName":"CompaniesDropdown_menuClassName__3KZnD","icon":"CompaniesDropdown_icon__2xOIk"};